import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import Close from "../../assets/close.svg";
import DropDown from "../../formComponents/DropDown";
import InlineInput from "../../formComponents/InlineInput";
import FormButton from "../../formComponents/FormButton";

// hooks
import useGetFetchFromId from "../../hooks/useGetFetchFromId";
import { useEscape } from "../../hooks/useEscape";

// store
import {
  userStore,
  selectOptionsStore,
  dbDataStore,
  projectStore,
  messageAndErrorStore,
} from "../../store/Store";

export default function AddCreditDebit({ setTrigger, setEditId, docId }) {
  // global
  const currentUser = userStore((data) => data.currentUser);
  const JwtToken = userStore((data) => data.JwtToken);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const currentProject = projectStore((data) => data.currentProject);
  const projectCustomerInvoices = projectStore(
    (data) => data.projectCustomerInvoices
  );
  const projectVendorInvoices = projectStore(
    (data) => data.projectVendorInvoices
  );
  const projectCarriers = projectStore((data) => data.projectCarriers);
  const setProjectCreditsDebits = projectStore(
    (data) => data.setProjectCreditsDebits
  );
  const setProjectTotals = projectStore((data) => data.setProjectTotals);
  const carrierOptions = selectOptionsStore((data) => data.carrierOptions);
  const terminalOptions = selectOptionsStore((data) => data.terminalOptions);
  const companyData = dbDataStore((data) => data.companyData);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  // local
  const [vendorDD, setVendorDD] = useState(null);
  const [pending, setPending] = useState(false);
  const [recordType, setRecordType] = useState(null);
  const [companyType, setCompanyType] = useState(null);
  const [invoiceOptions, setInvoiceOptions] = useState(null);
  const [newCreditDebit, setNewCreditDebit] = useState({
    id: 0,
    project_id: currentProject.project.id,
    vendor_name: "",
    is_credit: false,
    amount: 0,
    is_vendor: false,
    invoice_type: "",
    invoice_id: 0,
    created_by_id: currentUser.id,
    updated_by_id: currentUser.id,
  });
  
  const recordTypeOptions = [
    { value: 1, label: "Credit" },
    { value: 2, label: "Charge" },
  ];

  const companyTypeOptions = [
    { value: 1, label: "Customer" },
    { value: 2, label: "Vendor" },
  ];

  const vendorInvoiceTypeOptions = [
    { value: 1, label: "Freight" },
    { value: 2, label: "Sand" },
    { value: 3, label: "Asset" },
  ];
  const customerInvoiceTypeOptions = [
    { value: 1, label: "Freight" },
    { value: 2, label: "Asset" },
  ];
  var id = 0;
  if (docId) {
    id = docId;
  }
  const navigate = useNavigate();

  // get invoice options
  useEffect(() => {
    const dropdown = [];
    if (!newCreditDebit.is_vendor) {
      if (projectCustomerInvoices) {
        if (newCreditDebit.invoice_type === "Freight") {
          projectCustomerInvoices.forEach((i) => {
            if (!i.is_asset)
              dropdown.push({ value: i.id, label: i.invoice_name });
          });
        } else if (newCreditDebit.invoice_type === "Asset") {
          projectCustomerInvoices.forEach((i) => {
            if (i.is_asset)
              dropdown.push({ value: i.id, label: i.invoice_name });
          });
        }
      }
    } else if (newCreditDebit.is_vendor && projectVendorInvoices.invoices) {
      if (newCreditDebit.invoice_type === "Freight") {
        projectVendorInvoices.invoices.forEach((i) => {
          if (
            !i.is_sand &&
            !i.is_asset &&
            i.vendor_name === newCreditDebit.vendor_name
          ) {
            dropdown.push({ value: i.id, label: i.invoice_name });
          }
        });
      } else if (newCreditDebit.invoice_type === "Sand") {
        projectVendorInvoices.invoices.forEach((i) => {
          if (
            i.is_sand &&
            !i.is_asset &&
            i.vendor_name === newCreditDebit.vendor_name
          ) {
            dropdown.push({ value: i.id, label: i.invoice_name });
          }
        });
      } else if (newCreditDebit.invoice_type === "Asset") {
        projectVendorInvoices.invoices.forEach((i) => {
          if (
            !i.is_sand &&
            i.is_asset &&
            i.vendor_name === newCreditDebit.vendor_name
          ) {
            dropdown.push({ value: i.id, label: i.invoice_name });
          }
        });
      }
    }
    setInvoiceOptions(dropdown);
  }, [newCreditDebit, projectVendorInvoices.invoices, projectCustomerInvoices]);

  // get vendor dropdown
  useEffect(() => {
    const dropdown = [];
    if (currentProject && companyData) {
      const company = companyData.filter(
        (x) => x.id === currentProject.project.vendor_id
      );
      if (company.length > 0) {
        dropdown.push({
          value: currentProject.project.vendor_id,
          label: company[0].company_name,
        });
      }
    }
    if (carrierOptions && projectCarriers) {
      carrierOptions.forEach((c) => {
        const addedCarrier = projectCarriers.filter(
          (x) => x.pc_carrier_id === c.value
        );
        if (addedCarrier.length === 1) {
          dropdown.push({ value: c.value, label: c.label });
        }
      });
    }
    setVendorDD(dropdown);
  }, [
    currentProject,
    companyData,
    carrierOptions,
    setVendorDD,
    projectCarriers,
  ]);

  // get company type and record type if editing
  useEffect(() => {
    if (docId) {
      if (newCreditDebit.is_vendor) {
        setCompanyType({ value: 2, label: "Vendor" });
      } else {
        setCompanyType({ value: 1, label: "Customer" });
      }
      if (newCreditDebit.is_credit) {
        setRecordType({ value: 1, label: "Credit" });
      } else {
        setRecordType({ value: 2, label: "Charge" });
      }
    }
  }, [docId, setCompanyType, setRecordType, newCreditDebit]);

  const { error: retrievalError } = useGetFetchFromId(
    `${process.env.REACT_APP_BACKEND}/pc/credits-debits/${id}`,
    setNewCreditDebit,
    id
  );

  useEscape(setTrigger, [setEditId], [""], pending);

  const handleClose = () => {
    setTrigger(false);
    setEditId(null);
  };

  const handleSelect = (o, e) => {
    if (e.name === "company_type") {
      if (o.value === 1) {
        setNewCreditDebit({
          ...newCreditDebit,
          is_vendor: false,
        });
      } else if (o.value === 2) {
        setNewCreditDebit({
          ...newCreditDebit,
          is_vendor: true,
        });
      }
      setCompanyType(o);
    } else if (e.name === "record_type") {
      if (o.value === 1) {
        setNewCreditDebit({
          ...newCreditDebit,
          is_credit: true,
        });
      } else {
        setNewCreditDebit({
          ...newCreditDebit,
          is_credit: false,
        });
      }
      setRecordType(o);
    } else if (e.name === "invoice_type") {
      setNewCreditDebit({
        ...newCreditDebit,
        invoice_type: o.label,
      });
    } else if (e.name === "invoice_name") {
      setNewCreditDebit({
        ...newCreditDebit,
        invoice_id: o.value,
      });
    } else if (e.name === "vendor_name") {
      setNewCreditDebit({
        ...newCreditDebit,
        vendor_name: o.label,
      });
    }
  };

  const handleChange = (e) => {
    if (e.target.value === "") {
      setNewCreditDebit({
        ...newCreditDebit,
        amount: 0,
      });
    } else {
      setNewCreditDebit({
        ...newCreditDebit,
        amount: parseFloat(e.target.value),
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setPending(true);
    var method = "POST";
    if (id > 0) {
      method = "PATCH";
    }
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestBody = newCreditDebit;
    requestBody.created_by_id = currentUser.id;
    requestBody.updated_by_id = currentUser.id;
    const requestOptions = {
      method,
      headers,
      body: JSON.stringify(requestBody),
      signal: controller.signal,
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/credit-debit/${newCreditDebit.id}`,
      requestOptions
    )
      .then((res) => {
        if (res.status === 401) {
          setAuthStatus(false);
          navigate("/login");
          return;
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (data.error) {
          if (data.message === "project is archived and cannot be updated") {
            toggleNewMessage("Project is Archived and Cannot be Updated");
            setPending(false);
          }
          toggleNewMessage(data.message);
          setPending(false);
        } else {
          setProjectCreditsDebits(data.credits_debits);
          setProjectTotals(data.all_totals);
          setTrigger(false);
          setPending(false);
          setEditId(null);
          let message = newCreditDebit.is_credit ? "Credit" : "Charge";
          toggleNewMessage(null, `${message} Added`);
        }
      })
      .catch((err) => {
        toggleNewMessage(err);
        setPending(false);
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };

  return (
    <div className="popup">
      <div className="popup-inner">
        {retrievalError && <div className="error">{retrievalError}</div>}
        {!pending && (
          <div className="close">
            <img onClick={handleClose} src={Close} alt="close" />
          </div>
        )}
        <h3>Add Credit or Debit</h3>
        <form onSubmit={handleSubmit}>
          <DropDown
            name={"company_type"}
            title={"Company Type"}
            options={companyTypeOptions}
            onChange={handleSelect}
            value={companyType}
            placeholder={"Select Company Type"}
            classOne={"mb-3 row"}
            classTwo={"col-form-label bold-label col-sm-4"}
            classThree={"col-auto"}
            required={true}
          />
          <DropDown
            name={"record_type"}
            title={"Record Type"}
            options={recordTypeOptions}
            onChange={handleSelect}
            value={recordType}
            placeholder={"Select Record Type"}
            classOne={"mb-3 row"}
            classTwo={"col-form-label bold-label col-sm-4"}
            classThree={"col-auto"}
            required={true}
          />
          {newCreditDebit.is_vendor ? (
            <DropDown
              name={"invoice_type"}
              title={"Invoice Type"}
              options={vendorInvoiceTypeOptions}
              onChange={handleSelect}
              value={
                newCreditDebit.invoice_type === ""
                  ? ""
                  : vendorInvoiceTypeOptions.filter(
                      (x) => x.label === newCreditDebit.invoice_type
                    )
              }
              placeholder={"Select Record Type"}
              classOne={"mb-3 row"}
              classTwo={"col-form-label bold-label col-sm-4"}
              classThree={"col-auto"}
              required={true}
            />
          ) : (
            <DropDown
              name={"invoice_type"}
              title={"Invoice Type"}
              options={customerInvoiceTypeOptions}
              onChange={handleSelect}
              value={
                newCreditDebit.invoice_type === ""
                  ? ""
                  : customerInvoiceTypeOptions.filter(
                      (x) => x.label === newCreditDebit.invoice_type
                    )
              }
              placeholder={"Select Record Type"}
              classOne={"mb-3 row"}
              classTwo={"col-form-label bold-label col-sm-4"}
              classThree={"col-auto"}
              required={true}
            />
          )}
          {newCreditDebit.is_vendor &&
          (newCreditDebit.invoice_type === "Freight" ||
            newCreditDebit.invoice_type === "Asset") ? (
            <DropDown
              name={"vendor_name"}
              title={"Vendor"}
              options={vendorDD}
              onChange={handleSelect}
              value={vendorDD.filter(
                (x) => x.label === newCreditDebit.vendor_name
              )}
              placeholder={"Select Vendor"}
              classOne={"mb-3 row"}
              classTwo={"col-form-label bold-label col-sm-4"}
              classThree={"col-auto"}
              required={true}
            />
          ) : (
            newCreditDebit.is_vendor &&
            newCreditDebit.invoice_type === "Sand" && (
              <DropDown
                name={"vendor_name"}
                title={"Vendor"}
                options={terminalOptions}
                onChange={handleSelect}
                value={terminalOptions.filter(
                  (x) => x.label === newCreditDebit.vendor_name
                )}
                placeholder={"Select Vendor"}
                classOne={"mb-3 row"}
                classTwo={"col-form-label bold-label col-sm-4"}
                classThree={"col-auto"}
                required={true}
              />
            )
          )}
          <DropDown
            name={"invoice_name"}
            title={"Associated Invoice"}
            options={invoiceOptions}
            onChange={handleSelect}
            value={
              newCreditDebit.invoice_id === 0
                ? ""
                : invoiceOptions.filter(
                    (x) => x.value === newCreditDebit.invoice_id
                  )
            }
            placeholder={"Select Associated Invoice"}
            classOne={"mb-3 row"}
            classTwo={"col-form-label bold-label col-sm-4"}
            classThree={"col-auto"}
            required={true}
          />
          <InlineInput
            title={"Amount"}
            classname={"col-form-label bold-label col-sm-4"}
            type="number"
            name={"amount"}
            inputClass="col-auto"
            className={"sand-po-inputs"}
            placeholder={"Amount"}
            onChange={handleChange}
            value={newCreditDebit.amount === 0 ? "" : newCreditDebit.amount}
            step={0.01}
            required={true}
          />
          <FormButton pending={pending} name={"Submit"} />
        </form>
      </div>
    </div>
  );
}
